import { useState, useRef } from './basic'

const useDragAndDrop = onDrop => {
  const counter = useRef(0)
  const [dragging, setDragging] = useState(false)
  const onDrag = (update, extra) => e => {
    e.preventDefault()
    update && setDragging(!!(counter.current = update(counter.current || 0)))
    extra && extra(e.dataTransfer.files)
  }
  return {
    dragging,
    dragHandlers: {
      onDragOver: e => e.preventDefault(),
      onDragEnter: onDrag(count => count + 1),
      onDragLeave: onDrag(count => count - 1),
      onDrop: onDrag(
        () => 0,
        files => files?.length && onDrop(files)
      ),
    },
  }
}

export { useDragAndDrop as default, useDragAndDrop }
